import React, { Component } from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import dayjs from 'dayjs';
import { ThemeProvider } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import theme from "../styles/theme";
import Clipboard from "react-clipboard.js";
import Snackbar from '@mui/material/Snackbar';
import { BlueButton } from "../components/BlueButton";
import "../styles/style.css";

const BackIcon = "/assets/svg/back.svg";

class PaymentInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      openSnackbar: false,
      attempt: 0,
      ...this.props.location.state
    }
    // if (!this.state.id) {
    //   this.handleGetOrder();
    // }
  }

  handleClickOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleTest = () => {
    return (
      <Dialog
        open={this.state.isOpen}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Absensi</DialogTitle>
        <DialogContent>
          <DialogContentText>Isi data absensi.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="rate"
            label="Sesi Ke"
            type="number"
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={this.handleClose} color="primary">
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  setOpenSnackbar = () => {
    this.setState({
      openSnackbar: true
    })
  }

  setCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openSnackbar: false
    })
  }

  awaitingPaymentVirtualAccountScreen = () => {
    const bank_charge = 0
    const { order_detail, openSnackbar } = this.state
    const {
      number,
      amount,
      virtual_account,
      description,
      expired_at,
      customer
    } = order_detail

    return (
      <div className="wrapper">
        <div className="order-card" style={{ textAlign: "left", height: "auto", width: 320, display: "block", margin: "0 auto" }} >
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={openSnackbar}
            autoHideDuration={1000}
            onClose={this.setCloseSnackbar}
            action={
              <Button color="inherit" size="small" onClick={this.setCloseSnackbar}>
                Ok
              </Button>
            }
            message="Berhasil menyalin!" />
          <div style={{ padding: 10, fontSize: 14 }}>
            {/* <SnackbarContent open={openSnackbar} message="I love snacks." autoHideDuration={6000} action={action} /> */}
            <div style={{ textAlign: "center", padding: 5 }}>
              <b>{description}</b>
            </div>
            <hr />
            <div style={{ borderBottom: '1px dotted #000', padding: '10px 0' }}>
              <div>Nomor Tagihan</div>
              <div>
                {number}
              </div>
            </div>
            <div style={{ borderBottom: '1px dotted #000', padding: '10px 0' }}>
              <div>Nomor Virtual Account</div>
              <div>
                <span style={{ fontSize: '20px', marginTop: '5px', display: 'inline-block', color: "rgb(0, 191, 230)" }}>{virtual_account}</span>
                <div style={{ float: "right" }}>
                  <Clipboard component="div" onSuccess={() => this.setOpenSnackbar()} data-clipboard-text={virtual_account}>
                    <Button variant="outlined" >SALIN </Button>
                  </Clipboard>
                </div>
              </div>
            </div>
            <div style={{ borderBottom: '1px dotted #000', padding: '10px 0' }}>
              <div>Total Tagihan</div>
              <span style={{ fontSize: '20px', marginTop: '5px', display: 'inline-block' }}>
                <NumberFormat
                  value={amount + bank_charge}
                  displayType={"text"}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Rp "}
                />
              </span>
              <div style={{ float: "right" }}>
                <Clipboard component="div" onSuccess={() => this.setOpenSnackbar()} data-clipboard-text={amount + bank_charge}>
                  <Button variant="outlined" >SALIN </Button>
                </Clipboard>
              </div>
            </div>
            <div style={{ padding: '10px 0' }}>Bayar sebelum
              <span style={{ float: "right", fontSize: '14px' }}>
                {dayjs(expired_at).format("D MMM YYYY [Pukul] HH:mm:ss")}
              </span>
            </div>
          </div>
        </div>

        <div className="order-card" style={{ textAlign: "left", height: "auto", width: 320, display: "block", margin: "0 auto", marginTop: 10 }} >
          <div style={{ padding: 10, fontSize: 14 }}>
            <div style={{ padding: '10px 0' }}>Sudah transfer melalui <b>ATM / Internet / mobile banking</b>?</div>
            <div style={{ textAlign: 'center' }}>
              <BlueButton
                onClick={() => { this.props.history.push(`/transaksi/${order_detail.number}`); }}
                width={240}
                text="Saya Sudah Transfer"
              />
            </div>
          </div>
        </div>

        <div className="order-card" style={{ textAlign: "left", height: "auto", width: 320, display: "block", margin: "0 auto" }}>
          <div style={{ fontSize: 14 }}>
            <p style={{ textAlign: "center", padding: '20px 0 0' }}>
              <b>Petunjuk Pembayaran</b>
            </p>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} >Melalui ATM BSI</AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>Masukkan Kartu Anda. Pilih Bahasa dan Masukkan PIN ATM Anda.</li>
                  <li>Pilih Menu <b>Pembayaran</b>.</li>
                  <li>Pilih <b>Institusi / Akademik</b>.</li>
                  <li>Masukan kode institusi + nomor pembayaran: <b>9202 {virtual_account}</b>.</li>
                  <li>Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi sebesar{" "}<b><NumberFormat value={amount + bank_charge} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} /></b>, Konfirmasi apabila telah sesuai, lanjutkan transaksi.{" "}<b>Selesai</b>.</li>
                </ol>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>Melalui mobile banking BSI</AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>Pilih <b>Menu Pembayaran</b></li>
                  <li>Pilih <b>Institusi</b></li>
                  <li>Pilih <b>Nomor Rekening</b></li>
                  <li>Pilih <b>9202 - CV Pernik HSI AbdullahRoy</b> </li>
                  <li>Masukan Nomor Pembayaran : <b>{virtual_account}</b></li>
                  <li>Masukan nominal yg dibayarkan : <b><NumberFormat value={amount + bank_charge} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} /></b></li>
                  <li>Tekan tombol <b>Selanjutnya</b></li>
                  <li>Masukan PIN</li>
                  <li>Tekan tombol <b>Submit</b></li>
                </ol>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>Melalui NetBanking BSI</AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>Pilih Menu Pembayaran</li>
                  <li>Pilih Nomor Rekening BSI Anda</li>
                  <li>Pilih Jenis Pembayaran Institusi</li>
                  <li>Pilih Nama Lembaga : <b>CV Pernik HSI AbdullahRoy</b></li>
                  <li>Masukkan Nomor Pembayaran : <b>{virtual_account}</b></li>
                  <li>Tekan tombol verifikasi</li>
                  <li>Baca dengan seksama detail tagihan</li>
                  <li>Masukan TAN, PIN Otorisasi</li>
                  <li>Tekan tombol Submit</li>
                </ol>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>Pembayaran dari Bank Lain</AccordionSummary>
              <AccordionDetails>
                <ol>
                  <li>Pilih menu <b>Transfer Antar Bank</b> atau{" "}<b>Transfer Online Antarbank</b>.</li>
                  <li>Masukkan kode bank BSI: <b>451</b> atau pilih bank yangdituju yaitu <b>BSI</b>.</li>
                  <li>Masukkan nomor Virtual Account Anda:{" "}<b>900 9202 {virtual_account}</b>.</li>
                  <li>Masukkan nominal transfer sesuai tagihan Anda:{" "}<b><NumberFormat value={amount + bank_charge} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} /></b>.
                    <br /><b>*</b> <i>Nominal yang berbeda tidak dapat diproses</i>
                    <br /><b>*</b> <i><b>Tidak mendukung</b> BI-Fast, Flip, GoPay, OVO, DANA, LinkAja, dsb. Jadi gunakan transfer antar bank biasa (biasa nya dikenakan biaya Rp 6.500)</i>
                  </li>
                  <li>Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silakan lanjutkan transaksi sampai dengan selesai.</li>
                </ol>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { order_detail } = this.state
    return (
      <ThemeProvider theme={theme}>
        <div className="header">
          <Link
            to={`/transaksi/${order_detail.number}`}
            style={{
              position: "absolute",
              height: 60,
              width: 60,
              top: 0,
              left: 0
            }}
          >
            <img alt="icon" src={BackIcon} />
          </Link>
          <div className="center">
            <h3 className="title">Petunjuk Pembayaran</h3>
          </div>
        </div>
        {this.awaitingPaymentVirtualAccountScreen()}
      </ThemeProvider>
    );
  }
}

export default PaymentInstruction;
